import React from "react";
import Pricing from "@/pages/Pricing";
import { useEmployerPricingPreview } from "@/hooks/useEmployerPricingPreview";
import { PricingPreviewStatus } from "@/components/pricing/PricingPreviewStatus";

export default function AdminPricingPreview() {
    const state = useEmployerPricingPreview();
    return <div className="min-w-0" data-testid="admin-pricing-preview-page">
        <PricingPreviewStatus {...state} />
        {state.data && <Pricing employerPreview={state.data} />}
    </div>;
}